<mat-progress-bar  
[color]="loadingservice.barColor" 
[mode]="loadingservice.barMode" 
[value]="loadingservice.barValue" 
[bufferValue]="loadingservice.barBufferValue">
</mat-progress-bar>